export const SET_RELOAD = 'set_reload'

export function setReload (val) {
  return {
    type: SET_RELOAD,
    payLoad: val
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/apolloActions.js